/* src/app/components/recomendation-article-modal/recomendation-article-modal.component.scss */
.wrapper {
  padding: 20px 16px;
  padding-bottom: 85px;
  overflow: hidden;
  height: auto;
  min-height: 500px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background:
    linear-gradient(
      180deg,
      #1a1a1a 0%,
      #0d0d0d 100%);
  border-radius: 20px 20px 0 0;
}
@media (max-width: 992px) {
  .wrapper {
    padding: 18px 14px;
    padding-bottom: 80px;
  }
}
@media (min-width: 991px) {
  .wrapper {
    border-radius: 16px;
  }
}
.wrapper .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: rgba(255, 255, 255, 0.15);
  width: 40px;
  height: 40px;
  padding: 0px;
  z-index: 99;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrapper .close-icon:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.05);
}
.wrapper .close-icon:active {
  transform: scale(0.95);
}
.wrapper .close-icon ion-icon {
  width: 20px;
  height: 20px;
  margin: 0px;
  color: #00FFFF;
}
.wrapper .header-wrapper {
  text-align: center;
  width: 100%;
  margin-bottom: 15px;
}
.wrapper .title {
  font-family: AppFontSemiBold, sans-serif;
  width: 100%;
  font-size: 22px;
  text-transform: uppercase;
  color: #ffffff;
  padding: 5px 0px 8px;
  text-align: center;
  margin: 0;
  letter-spacing: 0.03em;
}
@media (max-width: 992px) {
  .wrapper .title {
    font-size: 20px;
  }
}
.wrapper .description {
  font-family: AppFont;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  padding: 0;
  margin: 0;
  text-align: center;
}
@media (max-width: 992px) {
  .wrapper .description {
    font-size: 13px;
  }
}
.content_block {
  flex: 1;
  width: 100%;
  overflow: auto;
  padding: 5px 0 10px;
  position: relative;
}
.footer-btn {
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
  width: calc(100% - 32px);
  display: flex;
  justify-content: center;
  z-index: 10;
}
.footer-btn ion-button {
  margin: 0;
  width: 100%;
  max-width: 100%;
  text-transform: uppercase;
  font-family: AppFontSemiBold, sans-serif;
  font-size: 15px;
  min-height: 50px;
  --border-radius: 12px;
}
.footer-btn ion-button.cancel-btn {
  --background: #004FFF;
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.08em;
}
@media (max-width: 992px) {
  .footer-btn ion-button {
    font-size: 14px;
    min-height: 48px;
  }
}
.footer-section {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 24px);
  z-index: 11;
}
/*# sourceMappingURL=recomendation-article-modal.component.css.map */
